import { render, staticRenderFns } from "./details-tab.vue?vue&type=template&id=0f61ad06&"
import script from "./details-tab.vue?vue&type=script&lang=js&"
export * from "./details-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports